import qs from 'qs';
import { omit, parseInt } from 'lodash/fp';
import { connect } from 'react-redux';
import {
  updateInventoryItem,
  fetchInventoryItem,
  fetchInventoryItemSkus,
  fetchInventoryItemAvailability
} from '../../../../../redux/Inventory/sagas/item/routines';
import {
  getItemForId,
  getIsFetching as getIsFetchingItem
} from '../../../../../redux/Inventory/selectors/item';
import {
  getIsFetching as getIsFetchingSkus,
  getSkusListForItemId
} from '../../../../../redux/Inventory/selectors/item/skus';
import {
  getIsSaving,
  getIsSaved,
  getAvailabilityForItemId,
  getIsFetchingByItem as getIsFetchingItemAvailability
} from '../../../../../redux/Inventory/selectors/item/availability';
import { ItemType } from '../../../../../constants/inventory/InventoryTypes';
import AdjustItem from '../../component';

function mapStateToProps(state, { location, match: { params } }) {
  const { id } = params;
  const { action, zoneId } = qs.parse(location.search, {
    ignoreQueryPrefix: true
  });
  return {
    action: parseInt(10, action),
    zoneId: zoneId ? parseInt(10, zoneId) : null,
    type: ItemType,
    item: getItemForId(state, id),
    skus: getSkusListForItemId(state, id),
    availability: getAvailabilityForItemId(state, id),
    isFetchingItem: getIsFetchingItem(state),
    iIsFetchingSkus: getIsFetchingSkus(state),
    isFetchingItemAvailability: getIsFetchingItemAvailability(state),
    isSaved: getIsSaved(state),
    isSaving: getIsSaving(state)
  };
}

function mapDispatchToProps(dispatch, { match: { params } }) {
  const { id } = params;
  return {
    onInit: () => {
      dispatch(fetchInventoryItem({ id }));
      dispatch(fetchInventoryItemSkus(id));
      dispatch(fetchInventoryItemAvailability(id));
    },
    onSubmit: body => {
      const omitProps = ['id', 'createdAt', 'updatedAt', 'deletedAt'];
      const payload = { id: body.id, body: omit(omitProps, body) };
      dispatch(updateInventoryItem(payload));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdjustItem);
